<template>
	<div
		@mousedown="onSelect(item)"
		@touchstart="onSelect(item)"
	>
		<span>{{ item.data.postal_code ? `${item.data.postal_code},` : '' }} {{ `${item.value}` }}</span>
	</div>
</template>

<script>
import daDataMixin from '~/mixins/daDataMixin';

export default {
	mixins: [daDataMixin],
};
</script>
